<template>
    <div v-if="false"></div>
</template>

<script>
import Projection from 'ol/proj/Projection'
import View from 'ol/View'

const rdProjection = new Projection({
    code: 'EPSG:28992',
    extent: [-285401.92, 22598.08, 595401.92, 903401.92],
})

export default {
    name: 'View',
    inject: ['map'],
    mounted() {
        this.view = new View({
            projection: rdProjection,
            constrainResolution: true,
            enableRotation: false,
            center: this.position.center,
            zoom: this.position.zoom,
            padding: this.padding,
        })

        this.map.setView(this.view)

        this.map.on('moveend', (e) => {
            this.$emit('position-changed', {
                center: this.view.getCenter(),
                zoom: this.view.getZoom(),
            })
        })
    },
    methods: {
        fit(geometryOrExtent, options) {
            this.view.padding = options.padding
            this.view.fit(geometryOrExtent, { duration: options.duration })
        },
        centerOn(coordinates, options) {
            this.view.padding = options.padding
            this.view.animate({ center: coordinates, duration: 100 })
        },
        adjustZoom(delta) {
            this.view.animate({ zoom: this.view.getZoom() + delta, duration: 100 })
        },
    },
    props: {
        position: Object,
        padding: Array,
    },
}
</script>

<style scoped></style>
